/**
 *  Header
 *    Scripts used for the header section.
 *    Contains examples of how to initialise topbar elements as a carousel,
 *    adding sticky header on scroll and a search bar hide/show via CSS class.
 *    The onCartUpdate method to add cart count is required for all sites.
 *    Keep the functionality of this file to do with the overall header.
 * 
 *  Version
 *    1.0.0 - 2022/07/22
 */

import {  CLASS_VISIBLE } from "../../tools/constants/classes";
import { cartGetCurrent, ON_CART_FINISHED } from '@process-creative/slate-theme-tools';
import { Section } from '../../tools/section';
import { Menu, SELECTOR_MENU } from './menu';

const SELECTOR_CONTAINER = '[data-header]';
const SELECTOR_CART_COUNT = '[data-cart-counter]';
const SELECTOR_ANNOUNCEMENT = '[data-announcement]';
const SELECTOR_HEADER_INNER = '.c-header__inner';

const ANNOUNCEMENT_CLASS = 'has-announcement'

class Header extends Section {
  private cartCountElement:HTMLElement | null = null;
  private menuElement:HTMLElement| null = null;
  private announcement: HTMLElement | null = null;
  private headerInner: HTMLElement | null = null;

  queryChildren(container: HTMLElement) {
    this.cartCountElement = container.querySelector(SELECTOR_CART_COUNT);
    this.menuElement = container.querySelector(SELECTOR_MENU);
    this.announcement = container.querySelector(SELECTOR_ANNOUNCEMENT);
    this.headerInner = container.querySelector(SELECTOR_HEADER_INNER); 
  }

  attachEvents() {
    //window.addEventListener(ON_CART_FINISHED, this.onCartUpdate);

    //Setup menu
    if(this.menuElement) new Menu(this.menuElement, this.container);

    this.setHeaderHeight();
    window.addEventListener("resize", () => {
      this.setHeaderHeight();
    });
  }

  detatchEvents() {
   // window.removeEventListener(ON_CART_FINISHED, this.onCartUpdate);
  }

  setHeaderHeight = () => {
    if(this.container.classList.contains(ANNOUNCEMENT_CLASS)) {
      let headerHeight = this.headerInner?.clientHeight ? this.headerInner.clientHeight : 0;
      let topbarHeight = this.announcement?.clientHeight ? this.announcement.clientHeight : 0;

      let headerTotalHeight:number = headerHeight + topbarHeight;
      this.container.style.height = `${headerTotalHeight}px`;
    }
  }

  onCartUpdate = () => {
    if(!this.cartCountElement) return;
    const count = cartGetCurrent()['item_count'] || 0;
    if(count > 0) {
      this.cartCountElement.classList.add(CLASS_VISIBLE);
    } else {
      this.cartCountElement.classList.remove(CLASS_VISIBLE);
    }
  }
}

Section.register(SELECTOR_CONTAINER, Header);